import { AxiosInstance } from 'axios';
import { generateSummaryId } from 'shared/utils/api/generateSummaryId';
import { AISummariesDto, AISummariesModel, mapAISummariesDtoToModel } from 'api/dto/AISummary.dto';
import {
  mapPerspectiveSummaryDtoToModel,
  PerspectiveSummaryDto,
  PerspectiveSummaryModel,
} from 'api/dto/new/Perspectives/PerspectiveSummary.dto';

export enum AISummaryFeedbackType {
  Positive = 'positive',
  Negative = 'negative',
}

export class AISummaryServiceApi {
  constructor(private client: AxiosInstance) {}

  get({
    pulseTemplateId,
    pulseId,
    departmentId,
    summaryNamespace,
  }: {
    pulseTemplateId: number;
    pulseId: number;
    departmentId?: number;
    summaryNamespace: string;
  }): Promise<AISummariesModel> {
    const summaryId = generateSummaryId({
      pulseTemplateId,
      pulseId,
      departmentId,
      summaryNamespace,
    });
    return this.client
      .get<AISummariesDto>(`/api/v1/summary/${summaryId}`)
      .then((response) => mapAISummariesDtoToModel(response.data));
  }

  getPerspectiveSummary({
    perspectiveId,
  }: {
    perspectiveId: string;
  }): Promise<PerspectiveSummaryModel> {
    return this.client
      .get<PerspectiveSummaryDto>(`/api/v1/summary/${perspectiveId}`)
      .then((response) => mapPerspectiveSummaryDtoToModel(response.data));
  }

  sendFeedback({
    pulseTemplateId,
    pulseId,
    departmentId,
    summaryNamespace,
    feedbackType,
    feedbackComment = '',
    sectionTitle,
  }: {
    pulseTemplateId: number;
    pulseId: number;
    departmentId?: number;
    summaryNamespace: string;
    feedbackType: AISummaryFeedbackType;
    feedbackComment?: string;
    sectionTitle: string;
  }): Promise<any> {
    const summaryId = generateSummaryId({
      pulseTemplateId,
      pulseId,
      departmentId,
      summaryNamespace,
    });
    return this.client.post<{
      feedbackType: AISummaryFeedbackType;
      feedbackComment: string;
      sectionTitle: string;
    }>(`/api/v1/summary/${summaryId}/feedback`, {
      feedbackType,
      feedbackComment,
      sectionTitle,
    });
  }
}
